import { render, staticRenderFns } from "./FamilyPageHeader.vue?vue&type=template&id=58332424&"
import script from "./FamilyPageHeader.vue?vue&type=script&lang=ts&"
export * from "./FamilyPageHeader.vue?vue&type=script&lang=ts&"
import style0 from "./FamilyPageHeader.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCol,VRow,VSwitch})
